import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem, DebugView } from '@/ui';
import { DateFormatter } from '@/features/shared/DateFormatter';

export type IncidentTimePanelItemsProps = {
  incidentId: string;
  purpose: 'Real' | 'Test' | 'Demo';
  createdAtUtc: string;
  closedAtUtc: string | null;
  status: boolean;
  incidentIsReadOnly: boolean;
};

export function IncidentTimePanelItems({
  incidentId,
  purpose,
  createdAtUtc,
  closedAtUtc,
  status,
  incidentIsReadOnly,
}: IncidentTimePanelItemsProps) {
  const { t } = useTranslation();
  const closingTime = status === true ? closedAtUtc : null;

  return (
    <>
      <DebugView>
        <DataPanelInlineItem title="Incident ID" value={incidentId} allowCopyToClipboard />
        <DataPanelInlineItem title="Purpose" value={purpose} />
      </DebugView>

      <DataPanelInlineItem title={t('Incident_InfoPanel_CreatedTime')}>
        <DateFormatter
          date={createdAtUtc}
          updateIntervalMs={1000}
          formatType={incidentIsReadOnly ? 'calendar' : 'combined'}
        />
      </DataPanelInlineItem>

      {closingTime !== null && (
        <DataPanelInlineItem title={t('Incident_InfoPanel_ClosingTime')}>
          <DateFormatter
            date={closingTime}
            updateIntervalMs={1000}
            formatType={incidentIsReadOnly ? 'calendar' : 'combined'}
          />
        </DataPanelInlineItem>
      )}
    </>
  );
}
